@if (
  this.actionStack!.getValue('couvertureManuelleIPresenceCouverture') === 1
) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-couverture"
    [title]="'dashboard.cover' | translate"
    [content]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')].icon!
    "
    [color]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')].color!
    "
    [status]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')].title!
        | translate
    "
    [statusMode]="
      buttons[this.actionStack!.getValue('couvertureManuelleSEtatVolet')]
        .status!
    "
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}
